<template>
  <div>
    <h4 v-if="title">
      {{ title }}
    </h4>

    <ul
      :class="['items', {
        'items--structured': structured === false
      }]"
    >
      <li
        v-for="(item, index) in itemsToShow"
        :key="index"
      >
        <zg-tile
          :href="item.href"
          :text="item.text"
          :background="background"
          :product="item.product"
          :compact="structured"
          :tag="item.tag"
          :disabled="item.disabled"
          full-width
          full-width-mobile
        />
      </li>
    </ul>
    <zg-flex
      v-if="structured === false && items && items.length > 6 && (showLessText && showMoreText)"
      justify-content="center"
      class="show-more"
    >
      <zg-link-button
        v-if="items && items.length > 6"
        size="xsmall"
        link="#"
        :icons="{ right: showMore ? 'compress' : 'expand' }"
        @click.prevent.native="getItems()"
      >
        {{ showMore ? showLessText : showMoreText }}
      </zg-link-button>
    </zg-flex>
  </div>
</template>

<script>
  import ZgTile from '../ZgTile/ZgTile.vue'
  import ZgFlex from '../layout/flex/ZgFlex.vue'
  import ZgLinkButton from '../ZgLinkButton/ZgLinkButton.vue'

  export default {
    name: 'ZgLinkList',
    components: {
      ZgTile,
      ZgFlex,
      ZgLinkButton
    },
    props: {
      title: {
        type: String,
        required: false,
        default: ''
      },
      items: {
        type: Array,
        required: true,
        validator: items => Array.isArray(items) && items.length > 0 &&
          items.every(item =>
            item.text &&
            item.href
          )
      },
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: value => [
          'beige',
          'white'
        ].includes(value)
      },
      structured: {
        type: Boolean,
        required: false,
        default: true
      },
      showMoreText: {
        type: String,
        required: false,
        default: ''
      },
      showLessText: {
        type: String,
        required: false,
        default: ''
      }
    },
    data: () => ({
      showMore: false,
      itemsToShow: 0
    }),
    created () {
      if (this.structured) {
        this.itemsToShow = this.items
      } else {
        this.itemsToShow = this.items.slice(0, 6)
      }
    },
    mounted () {
      if (document.location.search?.includes('show-all-products')) this.getItems()
    },
    methods: {
      getItems () {
        this.showMore = !this.showMore
        this.itemsToShow = this.showMore ? this.items : this.items.slice(0, 6)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .items {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin: 0 0 rhythm(small);
    }

    &--structured {
      @include mq(medium) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        li {
          margin: 0 rhythm() rhythm(small) 0;

          &:nth-child(4n) {
            margin-right: 0;
          }
        }
      }

      @include mq(large) {
        li {
          &:nth-child(4n) {
            margin-right: rhythm();
          }

          &:nth-child(6n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .show-more {
    margin: rhythm(medium) 0 0;
  }
</style>
